import React from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  Spin,
  Icon,
  Button
} from 'antd';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRosters } from 'selectors/roster.selectors';
import settings from 'config/settings';
import REDUCER_KEY from 'reducers/reducer.keys';
import { list } from 'actions/index';
import { withRouter } from 'react-router-dom';
import { blockNavigation } from 'library/helpers';
import { addRosterBuilderToRoster } from 'actions/rosterBuilder.actions';

class RosterBuilderAddToRosterForm extends React.Component {
  isMounted = false;

  static propTypes = {
    loadRosterList: PropTypes.func.isRequired,
    rosterList: PropTypes.array,
    dispatchAddToRoster: PropTypes.func,
    form: PropTypes.object,
    rosterBuilder: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    isAddToRosterModalOpen: PropTypes.bool.isRequired
  };

  static defaultProps = {
    rosterList: [],
    dispatchAddToRoster() {
    },
    form: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      isRosterVersionDisabled: true,
      loading: false,
      isSuccess: false,
      rosterVersionsList: [],
      showWarningMessage: false,
      selectedRosterVersionId: '',
      errorMsg: ''
    };
  }

  componentDidMount() {
    this.isMounted = true;
    const { loadRosterList } = this.props;
    if (this.isMounted) {
      this.setState({ loading: true });
      loadRosterList()
        .then(
          (response) => {
            const rosterList = getRosters(response);
            if (rosterList.length > 0) {
              this.setState({
                loading: false,
              });
            }
          }
        );
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  handleOk = () => {
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        form.resetFields();
        const { rosterBuilder, dispatchAddToRoster } = this.props;
        const { id } = rosterBuilder;
        const body = {
          cycle: values.cycle,
          start: values.start,
          version_id: values.selectedRosterVersionId
        };
        this.setState({ loading: true }, () => {
          dispatchAddToRoster(id, body)
            .then(
              (response) => {
                blockNavigation(false);
                if (response) {
                  this.setState({ loading: false, isSuccess: true });
                }
              },
              (error) => {
                this.setState({ loading: false, isSuccess: false, errorMsg: error?.allErrors ? error?.allErrors[0] : 'There was some problem, Please try again!' }, () => {
                  form.setFieldsValue({
                    selectedRosterVersionId: ''
                  });
                });
              }
            );
        });
      }
    });
  }

  handleCancel = () => {
    const { form, onCancel } = this.props;
    form.resetFields();
    this.setState({
      isRosterVersionDisabled: true,
      showWarningMessage: false,
      errorMsg: ''
    });
    form.setFieldsValue({
      selectedRosterVersionId: ''
    });
    onCancel();
  }

  handleDropdownChange = (id) => {
    const { form } = this.props;
    this.setState({
      isRosterVersionDisabled: false,
      selectedRosterVersionId: '',
      errorMsg: ''
    }, () => {
      this.setState({
        showWarningMessage: false
      });
      form.setFieldsValue({
        selectedRosterVersionId: ''
      });
      this.loadRosterVersionItems(id);
    });
  };

  loadRosterVersionItems = (id) => {
    const { rosterList } = this.props;
    if (rosterList.length > 0) {
      const rosterVersions = rosterList.find(roster => roster.id === id).unPublishedRosterVersions || [];
      if (rosterVersions.length > 0) {
        this.setState({ rosterVersionsList: rosterVersions });
      }
      else {
        this.setState({ rosterVersionsList: [], showWarningMessage: true }, () => {
          this.setState({ isRosterVersionDisabled: true });
        });
      }
    }
  }

  handleCascadingDropdownChange = (rosterVersionId) => {
    this.setState({ selectedRosterVersionId: rosterVersionId, errorMsg: '' });
  };

  handleCycle = () => {
    this.setState({ errorMsg: '' });
  }

  handleDate = () => {
    this.setState({ errorMsg: '' });
  }

  validateCycle = (rule, value, callback) => {
    if (!value || /^\d+$/.test(value)) {
      if (value > 50) {
        callback('Cycle must not be greater than 50.');
      }
      else {
        callback();
      }
    }
    else {
      callback('Cycle must be a number');
    }
  };

  handleClose = async () => {
    await this.handleCancel();
    this.setState({
      isSuccess: false,
      selectedRosterVersionId: ''
    });
  }

  renderTitle = () => {
    const { rosterBuilder } = this.props;
    const { loading } = this.state;

    return (
     !loading
        ? <div><span className="bhp-title bhp-capitalize">Add to Roster - {rosterBuilder.name}</span></div> : null
    );
  }

  renderFooter = () => {
    const {
      loading, isSuccess, showWarningMessage
    } = this.state;
    if (loading) {
      return '';
    }
    if (isSuccess) {
      return (
        <Button key="close" type="primary" onClick={this.handleClose}>
          Close
        </Button>
      );
    }

    return (
      [
        <Button key="cancel" onClick={this.handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" disabled={showWarningMessage} onClick={this.handleOk}>
          Add to Roster
        </Button>
      ]
    );
  }

  render() {
    const {
      isAddToRosterModalOpen, rosterBuilder, rosterList, form
    } = this.props;
    const {
      isRosterVersionDisabled, loading, isSuccess, rosterVersionsList, selectedRosterVersionId, showWarningMessage, errorMsg
    } = this.state;

    const rosterOptions = rosterList.map(item => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));

    const rosterVersionsOptions = rosterVersionsList.map(item => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));

    return (
      <Modal
        visible={isAddToRosterModalOpen}
        title={this.renderTitle()}
        titleFontSize={18}
        okText="Add to Roster"
        cancelText="Cancel"
        maskClosable={false}
        closable={false}
        footer={this.renderFooter()}
      >
        <div className="bhp-rosterbuilder-addToRosterContainer">
          {loading && !isSuccess
            && (
            <div className="bhp-rosterbuilder-loader"><Spin indicator={<Icon type="loading" spin />} tip="Loading..." spinning={loading && !isSuccess} /></div>
          )}

          {!loading && !isSuccess
            && (
              <Form layout="vertical">
                <Form.Item
                  label="Roster"
                  name="selectedRosterId"
                  rules={[{ required: true, message: 'Please select a roster' }]}
                >
                  {form.getFieldDecorator('selectedRosterId', {
                    rules: [{ required: true, message: 'Please select a roster' }]
                  })(
                    <Select onChange={this.handleDropdownChange}>
                      {rosterOptions}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item
                  label="Roster Version"
                  name="selectedRosterVersionId"
                  rules={[{ required: true, message: 'Please select a roster version' }]}
                >
                  {form.getFieldDecorator('selectedRosterVersionId', {
                    rules: [
                      { required: true, message: 'Please select a roster version' }
                    ],
                    initialValue: selectedRosterVersionId
                  })(
                    <Select disabled={isRosterVersionDisabled} onChange={this.handleCascadingDropdownChange}>
                      {rosterVersionsOptions}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item
                  label="Start Date"
                  name="start"
                  rules={[{ required: true, message: 'Please select the start date' }]}
                >
                  {form.getFieldDecorator('start', {
                    rules: [{ required: true, message: 'Please select the start date' }]
                  })(
                    <DatePicker
                      showTime={{ format: 'HH:mm', defaultValue: moment('00:00', 'HH:mm') }}
                      format="DD-MM-YYYY HH:mm"
                      placeholder="Start Date"
                      disabled={false}
                      onChange={this.handleDate}
                    />
                  )}
                </Form.Item>

                <Form.Item
                  label="Cycle"
                  name="cycle"
                  rules={[
                    { required: true, message: 'Please input the cycle' },
                    { validator: this.validateCycle }
                  ]}
                >
                  {form.getFieldDecorator('cycle', {
                    rules: [
                      { required: true, message: 'Please input the cycle' },
                      { validator: this.validateCycle }
                    ]
                  })(<Input placeholder="Cycle" onChange={this.handleCycle} />)}
                </Form.Item>
              </Form>
            )}

          {!loading && isSuccess && (
            <div className="bhp-rosterbuilder-successContainer">
              <span>Added <b>{rosterBuilder.name}</b> to roster successfully.</span>
              <span className="bhp-rosterbuilder-successIconContainer"><Icon type="check-circle" className="bhp-rosterbuilder-successIcon" /></span>
            </div>
          )}

          {!loading && !isSuccess && errorMsg !== '' && (
            <div className="bhp-rosterbuilder-successContainer">
              <span style={{ color: '#f5222d' }}>{ errorMsg }</span>
            </div>
          )}

          {showWarningMessage && (
            <div style={{ color: '#f5222d' }}> There are no draft Roster Versions for the selected Roster.</div>
          )}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  rosterList: getRosters(state.api.rosters.data),
});

const mapDispatchToProps = dispatch => ({
  loadRosterList() {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    return dispatch(list(
      REDUCER_KEY.rosters.key, {
      page,
      pageSize,
      filters,
      sorted
    }
    ));
  },
  dispatchAddToRoster(id, values) {
    return dispatch(addRosterBuilderToRoster(id, values));
  },
});

const WrappedRosterBuilderAddToRosterForm = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(Form.create({})(RosterBuilderAddToRosterForm));

export default withRouter(WrappedRosterBuilderAddToRosterForm);
